import { motion } from "framer-motion";
import { format } from "date-fns";

import { cn } from "@/lib/utils";
import { DropIndicator } from "./drop-indicator";
import { CardType } from "./types";

import { useTodoViewModal } from "./hooks/use-todo-view-modal";

type CardProps = {
  cardInfo: CardType;
  handleDragStart: Function;
};

export const Card = ({ cardInfo, handleDragStart }: CardProps) => {
  const { onOpenChange, setTodo } = useTodoViewModal();

  return (
    <>
      <DropIndicator beforeId={cardInfo?.id} column={cardInfo?.column} />

      <motion.div
        layout
        layoutId={cardInfo?.id}
        draggable="true"
        onDragStart={(e) => handleDragStart(e, cardInfo)}
        className={cn(
          "cursor-grab rounded border bg-card dark:bg-neutral-800 p-3 active:cursor-grabbing shadow-sm"
        )}
        onClick={() => {
          onOpenChange(true);
          setTodo(cardInfo);
        }}
      >
        <h3 className="text-base font-medium text-card-foreground">
          {cardInfo?.title}
        </h3>
        <p className="text-xs text-card-foreground truncate">
          {cardInfo?.description}
        </p>

        <p className="text-right text-xs">
          {format(new Date(cardInfo?.createdAt as string), "PPP")}
        </p>
      </motion.div>
    </>
  );
};
